























































import Vue from 'vue'
import LivePatientStatusCard from '@/components/live-dashboard/LivePatientStatusCard.vue'
import LiveDashboardFilter from '@/components/live-dashboard/LiveDashboardFilter.vue'
import {
  LIVE_DASH_STOP_POLLING_TIMESTAMP,
  LIVE_DASHBOARD_TYPES,
  titleByLiveDashboardTypes,
} from '@/constants/live-dashboard'
import { ONE_MINUTE_TIMESTAMP } from '@/components/patient-stats/graphs/mapping-chart-options/constants'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import { ModuleNames } from '@/store/module-names'
import {
  ActionNames as PatientWithLiveDataActionNames,
  GetterNames as PatientWithLiveDataGetterNames,
  MutationNames as PatientWithLiveDataMutationNames,
} from '@/store/modules/patient-with-live-data-latest/keys'
import { getPatientName } from '@/utils/patients'
import { ActionNames as PatientActionNames, GetterNames as PatientGetterNames } from '@/store/modules/patient/keys'
import moment from 'moment-timezone'
import { LivePatientsWithHistories } from '@/store/modules/patient-with-live-data-latest/types'

const enum Filter {
  All = 'all',
  Live = 'live',
}
const filterOptions = [
  { label: 'ALL', value: Filter.All },
  { label: 'Live Patients', value: Filter.Live },
]

export default Vue.extend({
  components: {
    LivePatientStatusCard,
    LiveDashboardFilter,
  },
  data() {
    return {
      currentTab: LIVE_DASHBOARD_TYPES.OxygenSaturations,
      filterOptions,
      selectedFilter: filterOptions[0],
      stopPollingTimeout: null,
      pollingTime: 3000,
      isInitialized: false,
      isStoppedPolling: false,
      showResumeModal: false,

      //for window focus
      hidden: '',
      visibilityChange: '',
    }
  },
  computed: {
    ...mapState(ModuleNames.patientWithLiveDataLatest, ['lastUpdate', 'livePatientsWithHistories']),
    ...mapGetters(ModuleNames.patient, [PatientGetterNames.activePatients]),
    ...mapGetters(ModuleNames.patientWithLiveDataLatest, [PatientWithLiveDataGetterNames.patientWithLiveDataLatests]),
    activePatientIds() {
      return this[PatientGetterNames.activePatients].map(patient => patient.id)
    },
    filteredLivePatientsWithHistories() {
      return (this.livePatientsWithHistories as LivePatientsWithHistories[])
        .filter(patientWithHistories => this.activePatientIds.includes(patientWithHistories.id))
        .sort((a, b) =>
          getPatientName(a)
            .toLowerCase()
            .localeCompare(getPatientName(b).toLowerCase())
        )
    },
    lastUpdateLabel() {
      return moment(this.lastUpdate).format('ddd, MMM D hh:mm:ss A')
    },
  },
  created() {
    this.startWindowFocusHandling()
  },
  async mounted() {
    this[PatientWithLiveDataMutationNames.resetPatientWitLiveData]()
    await this[PatientActionNames.getPatients]()
    await this.fetchData()
    this.resumePolling()
    this.isInitialized = true
  },
  beforeDestroy(): void {
    this.stopPolling()
    document.removeEventListener(this.visibilityChange, this.handleVisibilityChange, false)
  },
  methods: {
    ...mapActions(ModuleNames.patient, [PatientActionNames.getPatients]),
    ...mapMutations(ModuleNames.patientWithLiveDataLatest, [PatientWithLiveDataMutationNames.resetPatientWitLiveData]),
    ...mapActions(ModuleNames.patientWithLiveDataLatest, [
      PatientWithLiveDataActionNames.getPatientWithLiveDataLatests,
    ]),
    resumePolling() {
      console.log(new Date(), 'start polling')
      this.isStoppedPolling = false
      this.hideResumeDialog()
      this.startPolling()
    },
    startPolling() {
      if (this.isStoppedPolling) return
      setTimeout(async () => {
        try {
          await this.fetchData()
        } catch (e) {
          console.log('error', e)
        }
        this.startPolling()
      }, this.pollingTime)
    },
    async fetchData() {
      await this[PatientWithLiveDataActionNames.getPatientWithLiveDataLatests]({
        startTimestamp: new Date().getTime() - ONE_MINUTE_TIMESTAMP,
        endTimestamp: new Date().getTime(),
      })
    },
    stopPolling() {
      this.isStoppedPolling = true
    },
    showResumeDialog() {
      this.showResumeModal = true
    },
    hideResumeDialog() {
      this.showResumeModal = false
    },
    startWindowFocusHandling() {
      // https://developer.mozilla.org/en-US/docs/Web/API/Page_Visibility_API
      if (typeof document.hidden !== 'undefined') {
        // Opera 12.10 and Firefox 18 and later support
        this.hidden = 'hidden'
        this.visibilityChange = 'visibilitychange'
      } else if (typeof (document as any).msHidden !== 'undefined') {
        this.hidden = 'msHidden'
        this.visibilityChange = 'msvisibilitychange'
      } else if (typeof (document as any).webkitHidden !== 'undefined') {
        this.hidden = 'webkitHidden'
        this.visibilityChange = 'webkitvisibilitychange'
      }

      document.addEventListener(this.visibilityChange, this.handleVisibilityChange, false)
    },
    handleVisibilityChange() {
      if (document[this.hidden]) {
        console.log(new Date(), 'lost focus')
        this.stopPollingTimeout = setTimeout(() => {
          console.log(new Date(), 'stop polling')
          this.stopPolling()
        }, LIVE_DASH_STOP_POLLING_TIMESTAMP)
      } else {
        window.clearTimeout(this.stopPollingTimeout)
        if (this.isStoppedPolling) this.showResumeDialog()
      }
    },
    shouldShowCard(patientWithHistories: LivePatientsWithHistories) {
      if (this.selectedFilter.value === Filter.All) return true
      return patientWithHistories.oxygenSaturations.length || patientWithHistories.pulseRates.length
    },
  },
})
